import React, { Component } from 'react'
import PropTypes from 'prop-types'

class Signup extends Component {
  constructor (props) {
    super(props)
  }

  render () {
    return (
      <section style={{ background: "url('img/hero-2.jpg') no-repeat" }} className='hero d-flex align-items-center'>
        <div className='container'>
          <form action='#'>
            <div className='row'>
              <div className='form-group col-lg-1'>
                <input type='text' name='email' placeholder='Email' />
              </div>
            </div>
            <div className='row'>
              <div className='form-group col-lg-1'>
                <input type='password' name='password' placeholder='Password' />
              </div>
            </div>
            <div className='row'>
              <div className='form-group col-lg-1'>
                <input type='password' name='password-confirm' placeholder='Password' />
              </div>
            </div>
            <div className='row'>
              <div className='form-group col-lg-1'>
                <input type='submit' onClick={(event) => {
                  event.preventDefault()
                  this.props.signup('themikejahn@gmail.com', 'June2020!')
                }} value='Signup' className='btn btn-primary submit' />
              </div>
            </div>
          </form>
        </div>
      </section>
    )
  }
}
Signup.propTypes = {

}
export default Signup



// WEBPACK FOOTER //
// ./src/routes/Signup/components/Signup.js